module.exports = __webpack_public_path__ + "img/video-call3.fbb86860.svg";